'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
var settings = require('./settings-9ee2f03f.js');
require('./_commonjsHelpers-3fc1f64e.js');
require('./_react_commonjs-external-30e5c7b3.js');
require('./_prop-types_commonjs-external-c51b2bd5.js');
require('lodash/camelCase');
require('lodash/upperFirst');
var icon = require('./icon.js');
var number_format = require('./number_format-33e3898d.js');
var range = _interopDefault(require('lodash/range'));

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  font-family: \"Source Sans Pro\", sans-serif;\n  color: ", ";\n  position: relative;\n  height: ", ";\n  display: flex;\n  justify-content: center;\n  @media (max-width: 991px) {\n    height: auto;\n    flex-direction: column;\n    align-items: center;\n  }\n"], ["\n  font-family: \"Source Sans Pro\", sans-serif;\n  color: ", ";\n  position: relative;\n  height: ", ";\n  display: flex;\n  justify-content: center;\n  @media (max-width: 991px) {\n    height: auto;\n    flex-direction: column;\n    align-items: center;\n  }\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  height: 100%;\n  > button {\n    &:first-child {\n      border-left: 1px solid ", ";\n      border-top-left-radius: 5px;\n      border-bottom-left-radius: 5px;\n    }\n    &:last-child {\n      border-top-right-radius: 5px;\n      border-bottom-right-radius: 5px;\n    }\n  }\n  @media (max-width: 991px) {\n    height: ", ";\n  }\n"], ["\n  height: 100%;\n  > button {\n    &:first-child {\n      border-left: 1px solid ", ";\n      border-top-left-radius: 5px;\n      border-bottom-left-radius: 5px;\n    }\n    &:last-child {\n      border-top-right-radius: 5px;\n      border-bottom-right-radius: 5px;\n    }\n  }\n  @media (max-width: 991px) {\n    height: ", ";\n  }\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  width: ", ";\n  height: 100%;\n  border: 1px solid ", ";\n  border-left: none;\n  background: ", ";\n  color: ", ";\n  font-weight: bold;\n  text-align: center;\n  cursor: pointer;\n  &.current {\n    transition: background ease 0.2s;\n    background-color: ", ";\n    color: ", ";\n    cursor: default;\n  }\n  &.leftArrow {\n    width: 32px;\n    padding-right: 3px;\n  }\n  &.rightArrow {\n    width: 32px;\n    padding-left: 3px;\n  }\n"], ["\n  width: ", ";\n  height: 100%;\n  border: 1px solid ", ";\n  border-left: none;\n  background: ", ";\n  color: ", ";\n  font-weight: bold;\n  text-align: center;\n  cursor: pointer;\n  &.current {\n    transition: background ease 0.2s;\n    background-color: ", ";\n    color: ", ";\n    cursor: default;\n  }\n  &.leftArrow {\n    width: 32px;\n    padding-right: 3px;\n  }\n  &.rightArrow {\n    width: 32px;\n    padding-left: 3px;\n  }\n"]),
    _templateObject4 = _babelHelpers.taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  font-size: 16px;\n  @media (max-width: 991px) {\n    position: relative;\n    margin-bottom: 10px;\n  }\n"], ["\n  position: absolute;\n  left: 0;\n  font-size: 16px;\n  @media (max-width: 991px) {\n    position: relative;\n    margin-bottom: 10px;\n  }\n"]),
    _templateObject5 = _babelHelpers.taggedTemplateLiteral(["\n  width: 107px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  margin-left: 10px;\n  border-radius: 5px;\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  @media (max-width: 991px) {\n    height: ", ";\n    margin-left: 0;\n    margin-top: 10px;\n  }\n  &:focus-within {\n    border: 1px solid ", ";\n  }\n  &:focus-within button {\n    color: ", ";\n  }\n"], ["\n  width: 107px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  margin-left: 10px;\n  border-radius: 5px;\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  @media (max-width: 991px) {\n    height: ", ";\n    margin-left: 0;\n    margin-top: 10px;\n  }\n  &:focus-within {\n    border: 1px solid ", ";\n  }\n  &:focus-within button {\n    color: ", ";\n  }\n"]),
    _templateObject6 = _babelHelpers.taggedTemplateLiteral(["\n  max-width: 80px;\n  height: 100%;\n  padding-left: 10px;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 14px;\n  box-sizing: border-box;\n  ::placeholder {\n    color: ", ";\n  }\n"], ["\n  max-width: 80px;\n  height: 100%;\n  padding-left: 10px;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 14px;\n  box-sizing: border-box;\n  ::placeholder {\n    color: ", ";\n  }\n"]),
    _templateObject7 = _babelHelpers.taggedTemplateLiteral(["\n  height: 100%;\n  padding-left: 0;\n  padding-right: 10px;\n  border: none;\n  background: none;\n  color: ", ";\n  cursor: pointer;\n"], ["\n  height: 100%;\n  padding-left: 0;\n  padding-right: 10px;\n  border: none;\n  background: none;\n  color: ", ";\n  cursor: pointer;\n"]);

var PAGINATION_HEIGHT = "40px";

var Container = styled__default.div(_templateObject, settings.COLOR.textBlack, PAGINATION_HEIGHT);

var Pager = styled__default.div(_templateObject2, settings.COLOR.lineGrey, PAGINATION_HEIGHT);

var PagerBtn = styled__default.button(_templateObject3, PAGINATION_HEIGHT, settings.COLOR.lineGrey, settings.COLOR.selectionGrey, settings.COLOR.paginationBlue, settings.COLOR.paginationBlue, settings.COLOR.white);

var Label = styled__default.div(_templateObject4);

var InputContainer = styled__default.div(_templateObject5, settings.COLOR.lightGray, PAGINATION_HEIGHT, settings.COLOR.brightBlue, settings.COLOR.brightBlue);

var Input = styled__default(number_format.NumberFormat)(_templateObject6, settings.COLOR.lightGray);

var InputArrow = styled__default.button(_templateObject7, settings.COLOR.paginationBlue);

var getCurrentPage = function getCurrentPage(page, maxPage) {
  var currentPage = page;
  if (currentPage > maxPage) currentPage = maxPage;else if (currentPage <= 0) currentPage = 1;

  return currentPage;
};

var getPaginationDetail = function getPaginationDetail(page, perPage, maxPage, total) {
  var startPage = void 0;
  var endPage = void 0;
  if (maxPage <= 5) {
    startPage = 1;
    endPage = maxPage;
  } else if (page <= 3) {
    startPage = 1;
    endPage = 5;
  } else if (page + 2 >= maxPage) {
    startPage = maxPage - 4;
    endPage = maxPage;
  } else {
    startPage = page - 2;
    endPage = page + 2;
  }

  var startIndex = (page - 1) * perPage;
  var endIndex = Math.min(startIndex + perPage - 1, total - 1);
  var pages = range(startPage, endPage + 1);

  return {
    currentPage: page,
    perPage: perPage,
    maxPage: maxPage,
    startPage: startPage,
    endPage: endPage,
    pages: pages,
    startIndex: startIndex,
    endIndex: endIndex,
    total: total
  };
};

var Pagination = function Pagination(_ref) {
  var className = _ref.className,
      _ref$isShowStatus = _ref.isShowStatus,
      isShowStatus = _ref$isShowStatus === undefined ? false : _ref$isShowStatus,
      _ref$isShowInput = _ref.isShowInput,
      isShowInput = _ref$isShowInput === undefined ? false : _ref$isShowInput,
      total = _ref.total,
      _ref$perPage = _ref.perPage,
      perPage = _ref$perPage === undefined ? 10 : _ref$perPage,
      _ref$page = _ref.page,
      page = _ref$page === undefined ? 1 : _ref$page,
      _ref$maxPage = _ref.maxPage,
      maxPage = _ref$maxPage === undefined ? Math.ceil(total / perPage) : _ref$maxPage,
      _ref$onChangePage = _ref.onChangePage,
      onChangePage = _ref$onChangePage === undefined ? function () {} : _ref$onChangePage,
      _ref$onGetPager = _ref.onGetPager,
      onGetPager = _ref$onGetPager === undefined ? function () {} : _ref$onGetPager;

  var _React$useState = React__default.useState({}),
      _React$useState2 = _babelHelpers.slicedToArray(_React$useState, 2),
      pager = _React$useState2[0],
      setPager = _React$useState2[1];

  var _React$useState3 = React__default.useState(""),
      _React$useState4 = _babelHelpers.slicedToArray(_React$useState3, 2),
      input = _React$useState4[0],
      setInput = _React$useState4[1];

  var handleInitialSetPager = function handleInitialSetPager() {
    var currentPage = getCurrentPage(page, maxPage);

    var pagerObject = getPaginationDetail(currentPage, perPage, maxPage, total);
    setPager(pagerObject);
    onGetPager(pagerObject);
  };

  React__default.useEffect(function () {
    handleInitialSetPager();
  }, []);

  React__default.useEffect(function () {
    handleInitialSetPager();
  }, [total, perPage, page]);

  var handleSetPager = function handleSetPager(toPage) {
    var currentPage = getCurrentPage(toPage, maxPage);
    onChangePage(currentPage);

    var pagerObject = getPaginationDetail(currentPage, perPage, maxPage, total);
    setPager(pagerObject);
    onGetPager(pagerObject);

    setInput("");
  };

  if (!pager.pages || pager.pages.length <= 1) {
    return null;
  }

  return React__default.createElement(
    Container,
    { className: className },
    isShowStatus && React__default.createElement(
      Label,
      null,
      "Results ",
      pager.startIndex + 1,
      "-",
      pager.endIndex + 1,
      " of ",
      pager.total
    ),
    React__default.createElement(
      Pager,
      null,
      pager.currentPage !== 1 && React__default.createElement(
        PagerBtn,
        {
          className: "leftArrow",
          onClick: function onClick() {
            return handleSetPager(pager.currentPage - 1);
          } },
        React__default.createElement(icon.Icon, { name: "chevron-left", size: "sm", color: settings.COLOR.paginationBlue })
      ),
      pager.pages.map(function (p) {
        return React__default.createElement(
          PagerBtn,
          {
            key: p,
            className: pager.currentPage === p && "current",
            onClick: function onClick() {
              return handleSetPager(p);
            } },
          p
        );
      }),
      pager.currentPage !== pager.maxPage && React__default.createElement(
        PagerBtn,
        {
          className: "rightArrow",
          onClick: function onClick() {
            return handleSetPager(pager.currentPage + 1);
          } },
        React__default.createElement(icon.Icon, { name: "chevron-right", color: settings.COLOR.paginationBlue })
      )
    ),
    isShowInput && React__default.createElement(
      InputContainer,
      { onBlur: function onBlur() {
          return input && handleSetPager(Number(input));
        } },
      React__default.createElement(Input, {
        decimalSeparator: false,
        allowNegative: false,
        placeholder: "Go to page",
        value: input,
        onChange: function onChange(e) {
          return setInput(e.target.value);
        },
        onKeyPress: function onKeyPress(e) {
          return e.key === "Enter" && input && e.target.blur();
        }
      }),
      React__default.createElement(
        InputArrow,
        { onClick: function onClick() {
            return input && handleSetPager(Number(input));
          } },
        React__default.createElement(icon.Icon, { name: "chevron-right" })
      )
    )
  );
};

Pagination.propTypes = {
  /** class name of pagination */
  className: PropTypes$1.string,
  /** show detail e.g. "Results 1-8 of 60" */
  isShowStatus: PropTypes$1.bool,
  /** show input for searching */
  isShowInput: PropTypes$1.bool,
  /** number of total items */
  total: PropTypes$1.number,
  /** number of items per page */
  perPage: PropTypes$1.number,
  /** current page */
  page: PropTypes$1.number,
  /** maximum page */
  maxPage: PropTypes$1.number,
  /** return next page */
  onChangePage: PropTypes$1.func,
  /** return all pager detail */
  onGetPager: PropTypes$1.func
};
Pagination.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Pagination",
  "props": {
    "isShowStatus": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "show detail e.g. \"Results 1-8 of 60\""
    },
    "isShowInput": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "show input for searching"
    },
    "perPage": {
      "defaultValue": {
        "value": "10",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of items per page"
    },
    "page": {
      "defaultValue": {
        "value": "1",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "current page"
    },
    "maxPage": {
      "defaultValue": {
        "value": "Math.ceil(total / perPage)",
        "computed": true
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "maximum page"
    },
    "onChangePage": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "return next page"
    },
    "onGetPager": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "return all pager detail"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "class name of pagination"
    },
    "total": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of total items"
    }
  }
};

module.exports = Pagination;
//# sourceMappingURL=pagination.js.map
